<template>
  <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly && !hasProAccess, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly && !hasProAccess}">
    <v-flex xs12 sm11 offset-sm1>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <div class="app-panel white py-4" v-if="!hasProAccess" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
          <v-layout row wrap pb-3>
            <v-flex grow>
              <span class="subheading">Upgrade your account to Pro to use Chase emails.</span>
              <p class="mt-3">With the Pro plan, you can create your own schedule of automated late payment emails to remove the burden of managing late payments. Send these direct to your client or to yourself as a reminder to chase.</p>
              <v-btn class="v-btn--medium mb-4" depressed small color="primary" to="/settings/billing" >Upgrade my account</v-btn>
            </v-flex>
          </v-layout>
      </div>
      <v-form v-if="hasProAccess" v-model="valid" @submit.prevent="onSaveForm">
      <div class="save-but-sticky">
        <v-layout>
          <v-flex grow></v-flex>
          <v-flex shrink><v-btn depressed  color="primary" type="submit" :disabled="loading || !valid" :loading="loading">
          Save
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn></v-flex>
        </v-layout>
      </div>
      <v-layout>
        <v-flex xs12 >
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <v-layout row wrap pb-3>
              <v-flex xs12>
                <span class="subheading">Chase emails</span>
              </v-flex>
            </v-layout>
            <v-layout align-end row fill-height wrap mt-4>
              <v-flex xs12 row wrap>
                <p class="caption light text-xs-left mb-0">Do you want to send automatic chase emails?</p>
                <v-radio-group  v-model="sendChasers" hide-details row class="mt-0 pt-2 mb-3">
                    <v-radio color="primary" label="Yes" :value='true' ></v-radio>
                    <v-radio color="primary" label="No" :value='false'></v-radio>
                  </v-radio-group>
                <transition name="fade">
                  <div v-if="sendChasers">
                  <p class="caption light text-xs-left mb-0">Who receives the chase emails?</p>
                    <v-radio-group v-model="sendChasersTo" :disabled="!sendChasers" hide-details row class="mt-0 pt-2 mb-3">
                      <v-radio color="primary" label="Me and the customer" value="both"></v-radio>
                      <v-radio color="primary" label="Me only" value="me"></v-radio>
                    </v-radio-group>
                  </div>
                </transition>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-if="sendChasers">
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <v-layout row wrap pb-3>
              <v-flex xs12>
                <span class="subheading">Chase schedule</span>
                <p class="caption light">Add up to 10 automated chase emails.</p>
              </v-flex>
            </v-layout>
          </div>
            <v-layout >
              <v-flex xs12 row wrap>
                  <transition-group name="list" tag="p">
                    <div v-for="(email, itemsindex) in chaseEmails" :key="`key-${itemsindex}`" class="list-item white mt-2 mb-0 py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
                    <v-layout row wrap justify-space-between>
                      <v-flex xs8 >
                        <v-text-field
                        :name='`subject${itemsindex}`'
                        :id='`subject${itemsindex}`'
                        v-model="email.subject"
                        :rules="subjectRules"
                        label="Subject"
                        required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                        v-model.number="email.daysBeforeSend"
                        type="number"
                        label="Send after"
                        suffix="days"
                        :rules="numberRules"
                        ></v-text-field>
                      </v-flex>
                      <v-layout row wrap justify-space-between align-center>
                      <v-flex xs10 >
                        <v-textarea
                        :name='`body${itemsindex}`'
                        :id='`body${itemsindex}`'
                        label="Email body"
                        v-model="email.body"
                        placeholder=" "
                        auto-grow
                        rows="3"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs1 align-end>
                        <v-icon class="delete-icon small-icon error--text" @click="deleteChaseEmail(itemsindex)" >close</v-icon>
                      </v-flex>
                      </v-layout>
                    </v-layout>
                    </div>
                  </transition-group>
                  <div class="white py-4 my-0 py-0" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
                <v-btn @click='addChaseEmail'
                depressed
                color="primary"
                >Add chase email</v-btn>
                </div>
              </v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
      </v-form>
    </v-flex>
  <confirm ref="confirm"></confirm>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import Confirm from '@/components/Shared/Confirm'

export default {
  name: 'ChaseEmails',
  components: {
    Confirm
  },
  data () {
    return {
      group: this.$store.getters.group,
      sendChasers: this.$store.getters.group.sendChasers || false,
      sendChasersTo: this.$store.getters.group.sendChasersTo || 'both',
      user: this.$store.getters.user,
      valid: false,
      timescales: [
        { text: '1 day', value: '1' },
        { text: '7 days', value: '7' },
        { text: '14 days', value: '14' },
        { text: '30 days', value: '30' },
        { text: '60 days', value: '60' },
        { text: '90 days', value: '90' }
      ],
      // maybe in future at some point
      // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      // for now use the ipdata
      timezone: null,
      newTaxRate: null,
      chaseEmails: [],
      subjectRules: [
        v => !!v || 'Subject is required',
        v => v.length >= 4 || 'Subject must be more than 10 characters'
      ],
      numberRules: [
        v => Number.isInteger(Number(v)) || 'The value must be an integer number',
        v => v > 0 || 'The value must be greater than zero'
      ]
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    emailCount () {
      if (this.chaseEmails !== null) {
        return this.chaseEmails.length
      } else {
        return 0
      }
    },
    emptyChases () {
      if (this.emailCount === 0 && this.sendChasers) {
        return true
      } else {
        return false
      }
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  watch: {
    sendChasers (newValue, oldValue) {
      if (newValue === false) {
        this.chaseEmails = []
      }
    }
  },
  methods: {
    async onSaveForm () {
      try {
        await firebase.database().ref(`chase-emails/${this.user.group}`).set(this.chaseEmails)
        this.group.sendChasers = this.sendChasers
        this.group.sendChasersTo = this.sendChasersTo
        this.$store.dispatch('updateGroupSettings', this.group)
        this.$store.dispatch('addNotification', { text: 'Chase emails saved.', type: 'primary' })
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    addChaseEmail () {
      const newChaseEmail = {
        subject: 'Invoice {{invoice-number}} from {{company-name}} is overdue by {{days-overdue}} days.',
        body: `Invoice: {{invoice-number}}\r\nFrom: {{company-name}}\r\nFor: {{invoice-title}}\r\nOverdue: {{days-overdue}} days\r\n\r\nPlease make payment or contact {{company-name}}.`,
        daysBeforeSend: 30 + (this.emailCount * 30)
      }
      this.chaseEmails.push(newChaseEmail)
    },
    async deleteChaseEmail (emailIndex) {
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        this.chaseEmails.splice(emailIndex, 1)
      }
    },
    safeNumberOfDays (item) {
      if (!item.amount || isNaN(item.amount)) {
        item.amount = 0.00
      }
    },
    async fetchData () {
      try {
        const chaseEmailsRef = firebase.database().ref(`chase-emails/${this.user.group}`)
        const snapshot = await chaseEmailsRef.once('value')
        const chaseEmailsVal = snapshot.val()
        if (chaseEmailsVal) {
          this.chaseEmails = snapshot.val()
        }
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style lang="scss" scoped>
img.business-logo{
  max-width:100%;
  border:1px dashed grey;
  padding:20px;
}
.save-but-sticky {
  position:sticky;
  padding-bottom:10px;
  padding-top:10px;
  top:35px;
  z-index:1;
  background:#efefef;
  margin-bottom:40px;
  .mdAndDown &{
      top:50px;
  }
}
.line-delete{
  flex-shrink: 0;
  flex-basis:15px;
  margin-left:5px;
}
.small-icon{
  font-size:15px;
}
.list-item {
  display: block;
  // box-shadow: 0px 0px 10px 1px rgb(0 0 0 / 10%);
  padding:20px 20px;
  margin-bottom:30px;
}
.list-enter-active, .list-leave-active {
  transition: all .5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
</style>
